export default "__VITE_ASSET__CuHzNrm4__"